import useHeaderStore from '@/store/header';
import { IArea, IStoreLists } from '@/interfaces/store';
import { useSyncExternalStore } from 'react';

// Server default values needs to cached to avoid infinite re-renders
const serverStoreSnapshot = {} as IStoreLists;
const serverLocationSnapshot = {} as IArea;
const serverStoreIdsSnapshot = [''] as string[];
const serverExpressMessageSnapshot = '';
const serverIsExpressEnabledSnapshot = false;

export function useDeliveryOption() {
  const selectedStore = useSyncExternalStore(
    useHeaderStore.subscribe,
    () => useHeaderStore.getState().selectedStore,
    () => serverStoreSnapshot,
  );
  const myLocation = useSyncExternalStore(
    useHeaderStore.subscribe,
    () => useHeaderStore.getState().myLocation,
    () => serverLocationSnapshot,
  );
  const selectedStoreIds = useSyncExternalStore(
    useHeaderStore.subscribe,
    () => useHeaderStore.getState().selectedStoreIds,
    () => serverStoreIdsSnapshot,
  );
  const expressMessage = useSyncExternalStore(
    useHeaderStore.subscribe,
    () => useHeaderStore.getState().expressMessage,
    () => serverExpressMessageSnapshot,
  );
  const isExpressEnabled = useSyncExternalStore(
    useHeaderStore.subscribe,
    () => useHeaderStore.getState().isExpressEnabled,
    () => serverIsExpressEnabledSnapshot,
  );
  return { selectedStore, myLocation, selectedStoreIds, expressMessage, isExpressEnabled };
}
